import type { AutoriaAtendente } from '../types/negociacaoDetailUiTypes';

export const ROTULO_VOCE = 'Você';

/**
 * Rótulo de quem escreveu uma mensagem do lado do escritório. "Você" exige que o autor seja o
 * usuário logado: vários atendentes operam a mesma negociação, e quem lê a thread precisa saber
 * qual deles falou com a contraparte. Autor desconhecido (mensagem manual antiga, sem `senderId`)
 * fica "Humano" — atribuí-la a quem está olhando seria afirmar o que não se sabe.
 *
 * @example rotuloAtendente({ autorId: 'u2', autorNome: 'Lohana', usuarioAtualId: 'u1' }) // 'Humano (Lohana)'
 */
export const rotuloAtendente = ({
  autorId,
  autorNome,
  usuarioAtualId,
}: AutoriaAtendente): string => {
  if (autorId && autorId === usuarioAtualId) return ROTULO_VOCE;
  return autorNome ? `Humano (${autorNome})` : 'Humano';
};
